var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnFlagOff = function SvgIcnFlagOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.354 6.21c1.089.185 1.88 1.088 2.009 2.16l.97 8.03H6.667l.969-8.02c.13-1.076.928-1.981 2.023-2.166 1.7-.286 3.06-.283 4.694-.005Zm-4.47 7.516.603-4.705a.654.654 0 0 0-.58-.726.663.663 0 0 0-.743.565l-.603 4.705a.653.653 0 0 0 .578.725.663.663 0 0 0 .745-.564Z",
    fill: "#292525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19h12v-1.3H6V19Z",
    fill: "#292525"
  })));
};
export default SvgIcnFlagOff;